<template>
  <div class="compensation">
    <navbar title="补款管理"></navbar>
    <div class="flex1 workload flex-column h100">
      <div class="mt10">
        <el-card class="box-card">
          <div>
            <div class="inblock">
              <span class="demonstration">
                订单号 :
                <el-input v-model="from.order_no" placeholder="条形码输入" @keyup.enter.native='queryList'></el-input>
              </span>
            </div>
            <!--门店选择-->
            <div class="inblock time">
              <el-select v-model="from.shop_id" @change="shopidChage" placeholder="--请选择门店--">
                <el-option
                    v-for="(item,index) in allShop"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>

            <!--订单选择-->
            <div class="inblock time">
              <el-select v-model="from.is_online" @change="shopidChage" placeholder="--请选择订单类型--">
                <el-option
                    label="门店"
                    value="1">
                </el-option>
                <el-option
                    label="线上"
                    value="2">
                </el-option>
              </el-select>
            </div>

            <!--订单选择-->
            <div class="inblock time">
              <el-select v-model="from.status" @change="shopidChage" placeholder="--请选择订单状态--">
                <el-option
                    label="待补款"
                    value="1">
                </el-option>
                <el-option
                    label="已补款"
                    value="2">
                </el-option>
              </el-select>
            </div>

            <!--开始结束时间-->
            <div class="inblock time">
              开始/结束时间:
              <el-date-picker
                  v-model="time"
                  @change="DateChange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>

          </div>
        </el-card>
      </div>

      <div class="flex1 mt10">
        <el-table
            :data="tableData"
            border
            style="width: 100%"
            :height="tableHeight"
            :row-class-name="tableRowClassName">
          <el-table-column prop="startTime" label="订单号" sortable></el-table-column>
          <el-table-column prop="endTime" label="添加补款员工" sortable></el-table-column>
          <el-table-column prop="factory_member_name" label="补款金额"></el-table-column>
          <el-table-column prop="factory_position_id" label="实际补款金额"></el-table-column>
          <el-table-column prop="factory_position_id" label="补款原因"></el-table-column>
          <el-table-column prop="factory_position_id" label="用户姓名"></el-table-column>
          <el-table-column prop="factory_position_id" label="电话"></el-table-column>
          <el-table-column prop="factory_position_id" label="添加时间"></el-table-column>
          <el-table-column prop="factory_position_id" label="补款时间"></el-table-column>
          <el-table-column prop="totalCount" label="所属门店"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
    import header from '@/components/header'
    export default {
        components: {
            navbar: header
        },
        data() {
            return {
                tableHeight: window.innerHeight - 200,
                allShop: {},
                tableData: [],
                time: [new Date(), new Date()],
                from: {
                    token: JSON.parse(localStorage.getItem("userInfo")).token,
                    shop_id: '',
                    status: '',
                    is_online: '',
                    order_no: '',
                    start_time: '',
                    end_time: ''
                }
            }
        },
        created() {
            this.time[0] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D');
            this.time[1] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D');
            this.getAllShop()
        },
        methods: {
            tableRowClassName({ rowIndex }) {
                if (rowIndex % 2 == 0) {
                    return 'warning-row';
                }
                return '';
            },
            async queryList() {
                this.from.start_time = this.time[0];
                this.from.end_time	 = this.time[1];
                this.tableData = (await this.$http.extraList(this.from)).data.data.data;
                console.log("this.tableData ------: ", this.tableData)
            },
            shopidChage() {
                this.queryList();
            },
            // 时间被选择的时候，发送ajax
            DateChange() {
                this.queryList();
            },
            async getAllShop() {
               this.allShop = (await this.$http.allShop()).data.data;
               console.log(" allShop: ", this.allShop)
            }
        },
        name: "ReworkManagement"
    }
</script>

<style scoped lang="less">
  .el-input {
    width: auto !important;
  }
  .time {
    margin-left: 40px;
  }
</style>